import type { RouteRecordRaw, Router } from 'vue-router'
import { MODULE_ACCESS } from '@/modules/Core/constants/adminAccess'

const ProductAttributeRoutes: RouteRecordRaw = {
  path: '/productAttribute',
  name: 'ProductAttributeModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'ManageProductAttributeRoute',
      component: () => import('./views/ManageProductAttributeView.vue'),
      meta: {
        title: 'ویژگی های محصولات',
      },
    },
  ],
  meta: {
    layout: 'Default',
    allowedRoles: MODULE_ACCESS.productAttribute,
  },
}

export default (router: Router) => {
  router.addRoute(ProductAttributeRoutes)
}
